import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { translate } from "@/lib/uiStrings";

const STORAGE_KEY = "vmtipset_lang";

const LocaleContext = createContext({
  lang: "sv",
  setLang: () => {},
  t: (k, v) => k,
});

export function LocaleProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "en" ? "en" : "sv";
    } catch {
      return "sv";
    }
  });

  const setLang = useCallback((next) => {
    const v = next === "en" ? "en" : "sv";
    setLangState(v);
    try {
      localStorage.setItem(STORAGE_KEY, v);
    } catch {
      /* ignore */
    }
  }, []);

  const t = useCallback(
    (key, vars) => translate(lang, key, vars),
    [lang],
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}

export function useLocale() {
  return useContext(LocaleContext);
}
